module.exports = __webpack_public_path__ + "img/check-success.64b3cfda.svg";